import {updateIndicator} from './section-indicator';
import {toggleScrollify} from './scrollify-config'
import {scrollifyIsEnabled} from './media-query'
const Navigo = require('Navigo');

var isNavigating = false;
var usedLink = true;
var activeSectionName = '';
var $navItems = [];
var $scrollItems = [];
var initialPageLoad = true;

export function stopNavigating() {
    isNavigating = false;
}

const router = new Navigo(null, false);

export function configureRouter() {
    $navItems = $('.indicators');
    $navItems.children().each(function () {
        var sectionName = $(this).attr('data-indicator');
        $scrollItems.push($('.section[data-section-name="' + sectionName + '"]'));
    });
    router
      .on(
        function () {
            activeSectionName = 'home';
            showSection(activeSectionName);
        })
      .on(
        '/about', function () {
            activeSectionName = 'about';
            showSection(activeSectionName);
        })
      .on(
        '/contact', function () {
            activeSectionName = 'contact';
            showSection(activeSectionName);
        }, {
            after: function () {
                $('.cf-captcha').delay(400).animate({
                    'opacity': 1
                }, 400);
            },
            leave: function () {
                $('.cf-captcha').animate({
                    'opacity': 0
                }, 400);
            }
        })
      .resolve();
    $(window).on('scroll', function () {
        scrollspy($scrollItems);
    });
}

configureRouter();

function showSection(sectionName) {
    if (usedLink) {
        scrollToSection(sectionName);
    }
    updateIndicator($navItems, sectionName)
}

function scrollToSection(sectionName) {
    isNavigating = true;
    disableScroll();
    if (scrollifyIsEnabled) {
        toggleScrollify();
    }
    if (initialPageLoad) {
        router.historyAPIUpdateMethod('replaceState');
        if (sectionName === 'home') {
            afterAnimation() //no animation for section home
        } else {
            moveToSection(sectionName);
        }
    } else {
        moveToSection(sectionName);
    }
}

function afterAnimation() {
    if (scrollifyIsEnabled) {
        toggleScrollify();
    }
    if (initialPageLoad) {
        initialPageLoad = false;
    }
    isNavigating = false;
    enableScroll();
}

function moveToSection(sectionName) {
    var animationDuration = 1100;
    var animationDelay = 400;
    var scrollItem = $('.section[data-section-name="' + sectionName + '"]');
    var targetTop = scrollItem.offset().top;
    var currentScrollPosition = document.documentElement.scrollTop;
    if ((initialPageLoad && currentScrollPosition === 0) || !initialPageLoad) {
        if (initialPageLoad) {
            $('html, body').stop().delay(animationDelay).animate({
                scrollTop: targetTop
            }, animationDuration, 'easeOutExpo').promise().done(function () {
                afterAnimation();
            });
        } else {
            $('html, body').stop().animate({
                scrollTop: targetTop
            }, animationDuration, 'easeOutExpo').promise().done(function () {
                afterAnimation();
            });
        }
    } else {
        afterAnimation();
    }
}

function scrollspy(scrollItems) {
    if (!isNavigating && !initialPageLoad) {
        var scrollPos, changeBounds, i, l, activeSectionName;
        scrollPos = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        changeBounds = window.innerHeight / 2 || document.documentElement.clientHeight / 2;
        l = scrollItems.length;
        activeSectionName = '';

        for (i = 0; l > i; i++) {
            var item = scrollItems[i];
            if (item !== undefined) {
                if (scrollPos > (item.offset().top - changeBounds)) {
                    activeSectionName = $(scrollItems[i]).attr('data-section-name')
                }
            }
        }
        navigateOnScroll(activeSectionName);
    }
}

function navigateOnScroll(sectionName) {
    if (sectionName !== activeSectionName) {
        usedLink = false;
        var url = '/';
        if (sectionName !== 'home') {
            url += sectionName;
        }
        router.navigate(url, 'replaceState');
        usedLink = true;
    }
}

var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

function disableScroll() {
    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove = preventDefault; // mobile
    document.onkeydown = preventDefaultForScrollKeys;
}

export function enableScroll() {
    if (window.removeEventListener)
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
}



//////////////////
// WEBPACK FOOTER
// ./src/js/router.js
// module id = aWmp
// module chunks = 0